import React from "react"
import InformationLine from "../components/ui/InformationLine"
import TerminalLine from "../components/ui/TerminalLine"

const Introduction = () => {
  return (
    <div className="pt-4">
      <TerminalLine
        delay={0}
        hideDelay={6000}
        title="dragosnedelcu@md-pc:~$"
        content="cd ~/introduction"
      />
      <TerminalLine
        hideDelay={6000}
        delay={2500}
        title="dragosnedelcu@md-pc:~/introduction$"
        content="npm start"
      />

      <InformationLine
        delay={6200}
        hideDelay={9200}
        content="Starting presenting myself"
        loadingDots={true}
      />
      <InformationLine
        delay={9200}
        content="Compiled successfully!"
        loadingDots={false}
        className="text-green-500"
      />

      <InformationLine
        delay={9200}
        content={
          <span>
            You can now view
            <span className="font-bold"> Dragos Nedelcu </span> stack below.
          </span>
        }
        loadingDots={false}
      />

      <InformationLine
        delay={9200}
        content={
          <table>
            <tr>
              <td className="font-bold">Frontend:</td>
              <td className="pl-6">React, Gatsby, Next, Vue, Apollo Graphql</td>
            </tr>
            <tr>
              <td className="font-bold">Backend:</td>
              <td className="pl-6">Nodejs, Express, Nest, Hasura, Django</td>
            </tr>
            <tr>
              <td className="font-bold">Tools:</td>
              <td className="pl-6">
                Heroku, Vercel, Google Cloud Platform, AWS
              </td>
            </tr>
          </table>
        }
        className="pl-6"
        loadingDots={false}
      />

      <InformationLine
        delay={9200}
        content={
          <span>
            Note that the technologies above are{" "}
            <span className="text-primary-600">just tools</span>.
            <p>
              I am open to any other techologies as long as it fit the needs.
            </p>
          </span>
        }
        loadingDots={false}
      />
    </div>
  )
}

export default Introduction
